module.exports = __webpack_public_path__ + "static/media/login-bg-1.cad3879e.jpg";